<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Daftar Tunggakan</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">                            
                            <select class="form-control" v-model="tab">
                                <option>Laporan Tunggakan</option>
                                <option>Laporan Himpunan Tunggakan</option>
                                <option>Laporan Tunggakan Per Kecamatan</option>
                            </select>
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->                                
                <div v-if="tab == 'Laporan Tunggakan'">
                    <bhumie_tab_laporan_tunggakan></bhumie_tab_laporan_tunggakan>
                </div>
                <div v-if="tab == 'Laporan Himpunan Tunggakan'">
                    <bhumie_tab_laporan_himpunan_tunggakan></bhumie_tab_laporan_himpunan_tunggakan>
                </div>
                <div v-if="tab == 'Laporan Tunggakan Per Kecamatan'">
                    <bhumie_tab_laporan_tunggakan_perkecamatan></bhumie_tab_laporan_tunggakan_perkecamatan>
                </div>
        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: "Laporan Tunggakan"
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
